import api from '@/api'
// eslint-disable-next-line
import axios from '@/axios'
import qs from 'qs';

import upload from "../upload"

const path = '/SolicitudAltaMedica'

export default {
  cambiar(obj) {
    console.log("cambiar");
    return axios.post(`${api.url + path}/Cambiar`, obj)

  },
  cambiarestado(obj) {
    console.log("cambiar", obj);
    return axios.post(`${api.url + path}/CambiarEstado`, obj)

  },
  crear(obj) {
    console.log('crear solicitud', obj.uploadfile, obj);
    if(obj.uploadfile){
        return upload.upload(obj.formdata).then(result => {
            console.log('end upload', result);
            obj.Adjunto = result.data.FileName;
            return axios.post(`${api.url + path}/Crear`, obj);
        }).catch(err => {
            console.log('error upload', err);
            throw new Error('No se pudo subir el archivo adjunto', err);
        });
    }else{
        return axios.post(`${api.url + path}/Crear`, obj);
    }
  },
  agregarAdjunto(obj) {
    console.log('agregarAdjunto', obj.uploadfile, obj);
    return upload.upload(obj.formdata).then(result => {
      console.log('end upload', result);
      obj.Adjunto = result.data.FileName;
      return axios.post(`${api.url + path}/AgregarAdjunto`, obj);
    }).catch(err => {
        console.log('error upload', err);
        throw new Error('No se pudo subir el archivo adjunto', err);
    });
  },
  eliminar(obj) {
    console.log("eliminar");
    return axios.post(`${api.url + path}/Eliminar`, obj)

  },

  gets(id) {
    console.log("GetLista: ");
    return axios.get(`${api.url + path}/GetLista`,{
      params:{
        'listParams.id': id,
      }
    })
  },

  getCantidad (obj) {
    var urlrequest = api.url + path;
    console.log('getCantidad ', urlrequest, obj);
    return axios.get(`${urlrequest}/GetCantidad`,{
      params:obj
    })
  },
  get (obj) {
    var urlrequest = api.url + path;
    console.log('get ', urlrequest, obj);
    return axios.get(`${urlrequest}/Get`,{
      params:obj
    })
  },
  getHeatMap (obj) {
    var urlrequest = api.url + path;
    console.log('get ', urlrequest, obj);
    return axios.get(`${urlrequest}/GetHeatMap`,{
      params:obj
    })
  },
  find(obj) {
    console.log("find");
    return axios.post(`${api.url + path}/Eliminar`, obj)
  },

  getFormData(obj) {
    console.log("getFormData");
    return axios.get(`${api.url + path}/GetFormData`,{
      params: {
        'listParams.id': obj.id,
        'listParams.limit':obj.limit,
        'listParams.accionFormulario':obj.acciones
        }
    })
  },

  getLista(obj){
    console.log("getLista");
    return axios.get(`${api.url + path}/GetLista`,{
      params: obj
    })
  },
  getSolicitudUsuario(obj){
    console.log("getSolicitudUsuario");
    return axios.get(`${api.url + path}/GetLista`,{
      params:{
        'listParams.usuarioCarga_Id':obj.Id,
        'listParams.limit':obj.limit,
        'listParams.offset':obj.offset,
        'listParams.search':obj.search,
      }
    })
  },


}



// WEBPACK FOOTER //
// ./src/services/solicitudalta/index.js